import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'
import { formatUnix } from './time'

// tailwind-merge must know the console's own font sizes (ui/preset.ts):
// without this it reads `text-body` as a colour and drops it whenever a
// `text-foreground` sits in the same class list.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['micro', 'meta', 'table', 'body', 'section', 'title', 'stat'] }],
    },
  },
})

/** Tailwind class merger. Use instead of raw template literals. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** The old utils export, kept; the formatter lives in lib/time.ts. */
export const formatTime = formatUnix
